import camelCase from 'lodash/camelCase';

export default function getQueryField(prefix, hasLocalNews, byPath) {
  const queryField = hasLocalNews
    ? `${camelCase(prefix)}NewsArticle${byPath ? 'ByPath' : ''}`
    : 'newsArticle';
  return queryField;
}
